import React, { Component } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import style from "./SupplierRelatedParty.module.css";
import imageWhite from "../../assets/images/dashboard/supplier-related-party-white.svg";
import moment from "moment";
import { TableOptions } from "../../utils/messageConstants";
import { Link } from "react-router-dom";
import { checkIfPermitted, Permissions } from "../../services/RolePermissionService";

function dateFormatter(cell) {
  if (!cell) {
    return "";
  }
  return `${
    moment(cell).format("YYYY-MM-DD")
      ? moment(cell).format("YYYY-MM-DD")
      : moment(cell).format("YYYY-MM-DD")
  }`;
}
let order = "desc";

export class SupplierRelatedParty extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  handleBtnClick = () => {
    if (order === "desc") {
      this.refs.table.handleSort("asc", "name");
      order = "asc";
    } else {
      this.refs.table.handleSort("desc", "name");
      order = "desc";
    }
  };

  render() {
    const dashboardData = this.props.dashboardCounts;
    return (
      <div>
        <div className={`card ${style.supplierRelatedPartyCard}`}>
          <Link to={checkIfPermitted(Permissions.VIEW_CONTACTS_LIST)?{
            pathname: "/app/contacts",
            params: {
              lk_related_party_role_id: 1
            }
          }:"/app/dashboard"}>
            <div className={`card-header ${style.supplierRelatedPartyHeader}`}>
              <div className="d-flex align-items-center dashboard-list-box">
                <img src={imageWhite} alt="TSupplier Related Party" />
                Supplier Contacts
              </div>
              <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
            </div>
          <div className="card-body dashboard-time-table-wrapper">
            <BootstrapTable ref="table" data={dashboardData.relatedPartyList} options={TableOptions} version="4">
              <TableHeaderColumn
                dataField="party_name"
                isKey={true}
                // dataSort={true}
                width={"55%"}
              >
                Contact Name
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="created_at"
                // dataSort={true}
                dataFormat={dateFormatter}
                width={"45%"}
              >
                Date of Creation
              </TableHeaderColumn>
            </BootstrapTable>
          </div>
          </Link>
        </div>
      </div>
    );
  }
}


export default SupplierRelatedParty;

